import { createSelector } from 'reselect';
import { basketGreyBackgroundSelector } from 'selectors/testTarget/offers/basketGreyBackground/basketGreyBackgroundSelector';

const showSelector = createSelector(basketGreyBackgroundSelector, basketGreyBackground => !!basketGreyBackground.show);

export { showSelector };
